








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class EnterpriseAccessView extends Vue {
  @Prop({ default: () => [],  type: Array}) entIdList!: string[];

  extractEnterprise(groupId:string):string {
    let groupList = groupId.split('.');
    return groupList.length === 2 ? groupList[0] : groupId.split('.').slice(1, -1).join(' > ');
  }
}
